import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Components
import SectionDivider from '../molecules/SectionDivider';
import TextParagraph from '../atoms/TextParagraph';
import FormButton from '../atoms/FormButton';

//Returning the component
class ChangePassword extends Component {
	render() {
		return (
			<div className="changePassword margin-b-md">
				<SectionDivider heading="Password" />
				<div className="changePassword__info">
					<TextParagraph text="Sed ut perspiciatis unde omnis" />
					<FormButton text="Change password" classType="btn--fullWidthMobile"/>
				</div>
			</div>
		)
	}
}

//Making sure that it has a text property when it's declared
ChangePassword.propTypes = {
	test: PropTypes.string, //Write some props here if needed, just using this to not have errors
}

export default ChangePassword;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/ChangePassword.jsx